import { useAppSelector, useAppDispatch } from '@/hooks';

import { selectSnapshot } from '@/stores/slices/snapshot/selector';

import {
  getSnapshotListRequest,
  revertSnapshotRequest,
  resetSnapshotRequestStatus,
} from '@/stores/slices/snapshot/snapshot';

const useSnapshotHook = () => {
  const { getSnapshotListStatus, revertSnapshotStatus, snapshots } =
    useAppSelector(selectSnapshot);

  const dispatch: any = useAppDispatch();

  const requestSnapshotList = (params: any) =>
    dispatch(getSnapshotListRequest(params));

  const requestRevertSnapshot = (params: any) =>
    dispatch(revertSnapshotRequest(params));

  const requestResetSnapshot = () => dispatch(resetSnapshotRequestStatus());

  return {
    requestSnapshotList,
    requestRevertSnapshot,
    requestResetSnapshot,
    getSnapshotListStatus,
    revertSnapshotStatus,
    snapshots,
  };
};

export default useSnapshotHook;
